import ApiAuth from './ApiAuth'

export const Owners = {
    owners(context) {
        return new Promise((resolve, reject) => {
            ApiAuth().get('owners').then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    addOwner(context, data) {
        return new Promise((resolve, reject) => {
            ApiAuth().post('owner', data).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            })
        })
    },
    editOwner(context, data) {
        return new Promise((resolve, reject) => {
            ApiAuth().put(`owner/${data.id}`, data).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            })
        })
    },
    deleteOwner(context, data) {
        return new Promise((resolve, reject) => {
            ApiAuth().delete(`owner/${data.id}`, {
                data: {
                    newOwnerId: data.newOwnerId
                }
            }).then(response => {
                resolve(response.data);
            }).catch((error) => {
                console.log(error);
                reject(error.response);
            })
        })
    }
};
